// COMMERCE_UX1H_SECURE_SHIPPING_RATES_CLIENT_LOCK
// Browser calls Supabase Edge only.
// No Shippo secret and no direct Shippo API request.

import { supabase } from '../supabaseClient';

export type ForfyShippingAddress = {
  name: string;
  company?: string;
  street1: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone?: string;
  email?: string;
};

export type ForfyShippingParcel = {
  length: string;
  width: string;
  height: string;
  distance_unit: 'cm' | 'in';
  weight: string;
  mass_unit: 'kg' | 'lb';
};

export type ForfyShippingRate = {
  id: string;
  provider: string;
  service: string;
  amount: string;
  currency: string;
  estimatedDays: number | null;
  durationTerms: string;
  test: boolean;
};

export type ForfyShippingRatesResponse = {
  ok: boolean;
  error?: string;
  message?: string;
  missingFields?: string[];
  shipmentId?: string;
  shipmentStatus?: string;
  rates: ForfyShippingRate[];
  labelPurchased: false;
};

export type ForfyShippingRatesRequest = {
  order: Record<string, unknown> | null;
  addressFrom: ForfyShippingAddress;
  addressTo: ForfyShippingAddress;
  parcel: ForfyShippingParcel;
};

const FUNCTION_NAME = 'forfy-commerce-shippo-rates-preview';

const clean = (value: unknown) =>
  String(value ?? '')
    .replace(/shippo_(live|test)_[A-Za-z0-9_-]+/gi, '***SERVER_TOKEN_HIDDEN***')
    .slice(0, 400);

export const previewForfyShippingRates = async (
  payload: ForfyShippingRatesRequest,
): Promise<ForfyShippingRatesResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
      body: payload,
    });

    if (error) {
      return {
        ok: false,
        error: 'shipping_edge_error',
        message: clean(error.message || 'Tarifs indisponibles.'),
        rates: [],
        labelPurchased: false,
      };
    }

    return {
      ok: data?.ok === true,
      error: clean(data?.error),
      message: clean(data?.message),
      missingFields: Array.isArray(data?.missingFields)
        ? data.missingFields.map((field: unknown) => clean(field)).filter(Boolean)
        : [],
      shipmentId: clean(data?.shipmentId),
      shipmentStatus: clean(data?.shipmentStatus),
      rates: Array.isArray(data?.rates)
        ? data.rates.map((rate: any) => ({
            id: clean(rate?.id),
            provider: clean(rate?.provider || 'Transporteur'),
            service: clean(rate?.service || 'Service'),
            amount: clean(rate?.amount),
            currency: clean(rate?.currency || 'CAD'),
            estimatedDays: Number.isFinite(Number(rate?.estimatedDays))
              ? Number(rate.estimatedDays)
              : null,
            durationTerms: clean(rate?.durationTerms),
            test: Boolean(rate?.test),
          }))
        : [],
      labelPurchased: false,
    };
  } catch (error) {
    return {
      ok: false,
      error: 'shipping_network_error',
      message: clean(
        error instanceof Error
          ? error.message
          : 'Erreur réseau.'
      ),
      rates: [],
      labelPurchased: false,
    };
  }
};
